// Access token
export function getToken(state) {
  return state.access_token;
}

export function getUserId(state) {
  return state.access_token ? state.access_token.userId : "";
}
